import React from 'react';
import classes from './ResourcesSection.module.css';

import { GetFromLocalStorage, IsListEmpty, IsObjectEmpty, IsStringEmpty } from '../../../../utilities/CommonMethods';
import InPlacePlayer from '../../../InPlacePlayer/InPlacePlayer';
import PlayIcon from '../../../../assets/icons/icon-play-blue.svg';
import PlayIconBlack from '../../../../assets/icons/play-icon-black.svg';
import PlaylistIcon from '../../../../assets/icons/playlist-icon.png';
import ShowLoader from '../../../../hoc/ShowLoader/ShowLoader';
import ResourceAPIController from '../../../../webServices/ResourceAPIController';
import axios from 'axios';
import Constants from '../../../../utilities/Constants';
import { parseDate, parseTimeForDate } from '../../../../utilities/DateTimeUtils';

class ResourcesSection extends React.Component {

    state = {
        files: [],
        liveSessionRecordings: [],
        preWatchVideos: [],
        selectedResource: {},
        selectedResourceType: '',
        videoPlaying: false,
        showPlaylist: false,
        showResourceLoader: false,
        activeRecordingVideo: 0,
        activePreWatchVideo: -1,
        activeFile: -1,
        apiCallInProgress: false,
        fiftyPercentAttendanceMarked: false
    }

    onSessionRecordingClick = (recording, pos) => {
        let fiftyPercentAttendanceMarked = recording.attendanceMarked;

        this.setState({ selectedResource: recording, selectedResourceType: 'Video', showPlaylist: false, showResourceLoader: true, activeRecordingVideo: pos, activePreWatchVideo: -1, activeFile: -1, fiftyPercentAttendanceMarked: fiftyPercentAttendanceMarked })
    }

    onPreWatchVideoClick = (video, pos) => {
        this.setState({ selectedResource: video, selectedResourceType: 'Video', showPlaylist: false, showResourceLoader: true, activeRecordingVideo: -1, activePreWatchVideo: pos, activeFile: -1 })
    }

    onFileClick = (file, pos) => {
        const resourceType = file.type === 'embed' ? 'Embed' : 'File';

        this.setState({ selectedResource: file, selectedResourceType: resourceType, showPlaylist: false, showResourceLoader: true, activeRecordingVideo: -1, activePreWatchVideo: -1, activeFile: pos })
    }

    onVideoPlayClick = () => {
        const playState = this.state.videoPlaying;
        this.setState({ videoPlaying: !playState });
    }

    onPlaylistIconClick = () => {
        const playlistState = this.state.showPlaylist;
        this.setState({ showPlaylist: !playlistState });
    }

    onVideoLoaded = () => {
        this.setState({ showResourceLoader: false });
    }

    onFileLoaded = () => {
        this.setState({ showResourceLoader: false });
    }

    markStudentAttendance = (percent) => {

        const isLearner = GetFromLocalStorage(Constants.KEY_IS_LEARNER) === "true" ? true : false;

        let updatedResourceData = { ...this.state.selectedResource };
        if (this.state.selectedResource.attendanceMarked === false && this.state.apiCallInProgress === false && isLearner && percent > 50) {
            this.setState({ apiCallInProgress: true });

            let data = {
                "has_watched_recording": true,
                "watched_date_time": new Date().toISOString() // ISO Format "2021-07-27T16:02:08.070557"
            };


            ResourceAPIController.markStudentAttendance(this.state.selectedResource.liveSessionId, data)
                .then(response => {

                    updatedResourceData.attendanceMarked = true;

                    this.submitErrorLogOnFirebase(updatedResourceData, "Success", percent);

                    this.props.onSuccessDialogShow('Attendance marked successfully.', 'OKAY');
                    this.setState({ selectedResource: updatedResourceData, apiCallInProgress: false, fiftyPercentAttendanceMarked: true });
                })
                .catch(err => {
                    this.setState({ apiCallInProgress: false });
                    console.log('mark attendance error => ', err);
                    // this.submitErrorLogOnFirebase(updatedResourceData, "Failed", percent);
                });
        } else {
            this.submitErrorLogOnFirebase(updatedResourceData, "-", percent);
            this.setState({ fiftyPercentAttendanceMarked: true });
        }
    }

    submitErrorLogOnFirebase = (updatedResourceData, status, percent) => {
        let data = {
            "Attendance_Marked_Date": parseDate(new Date(), false, false) + ' @ ' + parseTimeForDate(new Date()),
            "Scheduled_Date": updatedResourceData.scheduledDate + ' @ ' + updatedResourceData.scheduledTime,
            "Live_Session_Id": updatedResourceData.liveSessionId,
            "Topic_Id": this.props.topicId,
            "Topic_Name": this.props.title,
            "Module_Name": this.props.moduleName,
            "Batch_Code": this.props.batchCode,
            "Email": GetFromLocalStorage(Constants.KEY_EMAIL),
            "UserName": GetFromLocalStorage(Constants.KEY_USERNAME),
            "Full_Name": GetFromLocalStorage(Constants.KEY_FULL_NAME),
            "API_Call_Status": status,
            "Watched_Percentage": percent,
            "Attendance_Marked": percent === 50 || status === 'Failed' ? false : true
        }
        axios.post(Constants.FIREBASE_STUDENT_ATTENDANCE_LOGS_URL, data);
    }

    showVideoLoadingError = () => {
        // this.submitErrorLogOnFirebase(updatedResourceData, "Video Load Error");
    }

    setResourceContent = () => {
        const files = [...this.props.topicResources.files],
            liveSessionRecordings = [...this.props.topicResources.liveSession],
            preWatchVideos = [...this.props.topicResources.preWatchVideos];

        let selectedResource = {}, resourceType = "", fiftyPercentAttendanceMarked = "";;

        if (!IsListEmpty(liveSessionRecordings) && (IsStringEmpty(this.props.id) || this.props.id === 2)) {
            selectedResource = liveSessionRecordings[0];

            fiftyPercentAttendanceMarked = selectedResource.attendanceMarked;

            resourceType = "Video";
        } else if (!IsListEmpty(preWatchVideos) && (IsStringEmpty(this.props.id) || this.props.id === 1)) {
            selectedResource = preWatchVideos[0];
            resourceType = "Video";
        } else if (!IsListEmpty(files) && (IsStringEmpty(this.props.id) || this.props.id === 3)) {
            selectedResource = files[0];
            resourceType = "File";
        }

        const playlistOpen = !IsListEmpty(liveSessionRecordings) && !IsStringEmpty(liveSessionRecordings[0].videoId) || (IsListEmpty(liveSessionRecordings) && IsListEmpty(preWatchVideos) && IsListEmpty(files)) ? false : true;

        this.setState({
            files: files,
            liveSessionRecordings: liveSessionRecordings,
            preWatchVideos: preWatchVideos,
            selectedResource: selectedResource,
            selectedResourceType: resourceType,
            showResourceLoader: true,
            showPlaylist: playlistOpen,
            activePreWatchVideo: IsListEmpty(liveSessionRecordings) || (!IsStringEmpty(this.props.id) && this.props.id === 1) ? 0 : -1,
            activeRecordingVideo: !IsListEmpty(liveSessionRecordings) || (!IsStringEmpty(this.props.id) && this.props.id === 3) ? 0 : -1,
            activeFile: !IsListEmpty(files) || (!IsStringEmpty(this.props.id) && this.props.id === 4) ? 0 : -1
        });
    }

    onEmbedVideoLoaded = () => {
        // alert("Loaded Successfully")
    }

    componentDidMount() {
        this.setResourceContent();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.title !== this.props.title || prevProps.id !== this.props.id || prevProps.topicResources.liveSession !== this.props.topicResources.liveSession) {
            this.setResourceContent();
        }
    }

    render() {

        const sessionRecording = !IsListEmpty(this.state.liveSessionRecordings) ? this.state.liveSessionRecordings.map((recording, index) => {
            return (
                <li className={classes.ListItem} key={index} onClick={() => this.onSessionRecordingClick(recording, index)}>
                    <div className={[classes.ListItemDiv, this.state.activeRecordingVideo === index && classes.ListItemDivSelected].join(' ')}>
                        <img src={this.state.activeRecordingVideo === index ? PlayIcon : PlayIconBlack} alt="Play Icon" className={[classes.PlayIcon, this.state.activeRecordingVideo === index ? classes.ActiveIcon : ''].join(' ')} />
                        Session Recording
                    </div>
                    {/* <span className={classes.Duration}>{recording.duration}</span> */}
                </li>
            )
        }) : null;


        const preWatchVideos = !IsListEmpty(this.state.preWatchVideos) ? this.state.preWatchVideos.map((video, index) => {
            return (
                <li className={classes.ListItem} key={index} onClick={() => this.onPreWatchVideoClick(video, index)}>
                    <div className={[classes.ListItemDiv, this.state.activePreWatchVideo === index && classes.ListItemDivSelected].join(' ')}>
                        <img src={this.state.activePreWatchVideo === index ? PlayIcon : PlayIconBlack} alt="Play Icon" className={[classes.PlayIcon, this.state.activePreWatchVideo === index ? classes.ActiveIcon : ''].join(' ')} />
                        {video.videoTitle}
                    </div>
                    {/* <span className={classes.Duration}>{video.duration}</span> */}
                </li>
            )
        }) : null;

        const files = !IsListEmpty(this.state.files) ? this.state.files.map((file, index) => {
            return (
                <li className={classes.ListItem} key={index} onClick={() => this.onFileClick(file, index)}>
                    <div className={[classes.ListItemDiv, this.state.activeFile === index && classes.ListItemDivSelected].join(' ')}>
                        <img src={this.state.activeFile === index ? PlayIcon : PlayIconBlack} alt="Play Icon" className={[classes.PlayIcon, this.state.activeFile === index ? classes.ActiveIcon : ''].join(' ')} />
                        {file.title}
                    </div>
                </li>
            )
        }) : null;

        let attendanceDurationPassed = false, markAttendance = false;

        if (!IsStringEmpty(this.state.selectedResource.liveSessionId)) {
            const scheduledDateTime = new Date(this.state.selectedResource.scheduledDate + ' ' + this.state.selectedResource.scheduledTime);
            attendanceDurationPassed = new Date().getTime() - scheduledDateTime.getTime() > (24 * 60 * 60 * 1000 * 7);
            markAttendance = this.state.selectedResource.attendanceMarked === false && attendanceDurationPassed === false;
        } else {
            attendanceDurationPassed = false;
            markAttendance = false;
        }

        // console.log("Final STatus: " + 'attendanceDurationPassed: ' + attendanceDurationPassed + ' markAttendance: ' + markAttendance);

        return (
            <div className={classes.ResourcesSectionContainer}>

                <img src={PlaylistIcon} alt="Show / Hide Resources Playlist" className={[classes.PlaylistIcon, !this.state.showPlaylist ? classes.Rotate : null].join(' ')} onClick={this.onPlaylistIconClick} />

                <div className={this.props.forCertification ? classes.ResourceDiv : classes.ForLearner}>
                    {
                        !IsObjectEmpty(this.state.selectedResource)
                            ? this.state.selectedResourceType === 'Video'
                                ? <div className={classes.PlayerContainerDiv}>
                                    {
                                        this.state.showResourceLoader && !IsStringEmpty(this.state.selectedResource.videoId)
                                            ? <div className={classes.LoaderContainer}>
                                                <ShowLoader isLoading={this.state.showResourceLoader} transparentBg={true} />
                                            </div> : null
                                    }
                                    {
                                        !IsStringEmpty(this.state.selectedResource.videoId)
                                            ? <InPlacePlayer
                                                markAttendance={markAttendance}

                                                fiftyPercentMarked={this.state.fiftyPercentAttendanceMarked}
                                                vimeoId={this.state.selectedResource.videoId}
                                                inline={false}
                                                play={this.state.videoPlaying}
                                                clicked={this.onVideoPlayClick}
                                                onVideoLoaded={this.onVideoLoaded}
                                                showVideoLoading={true}
                                                moduleName={this.props.moduleName}
                                                markStudentAttendance={this.markStudentAttendance}
                                            // showVideoLoadingError={this.showVideoLoadingError}
                                            />
                                            : <p className={classes.MessageText}>Session recording is not available yet!</p>
                                    }
                                </div>
                                : this.state.selectedResourceType === 'File'
                                    ? <div className={classes.FileContainerDiv}>
                                        {
                                            this.state.showResourceLoader && this.state.selectedResource.fileContent === null
                                                ? <div className={classes.LoaderContainer}>
                                                    <ShowLoader isLoading={this.state.showResourceLoader} grayBg={true} />
                                                </div>
                                                : null
                                        }
                                        {
                                            !IsStringEmpty(this.state.selectedResource.link)
                                                ?
                                                this.state.selectedResource.type === 'slide' ||
                                                    (
                                                        !IsStringEmpty(this.state.selectedResource.link) &&
                                                        (this.state.selectedResource.link.indexOf('.doc') !== -1 ||
                                                            this.state.selectedResource.link.indexOf('.ppt') !== -1 ||
                                                            this.state.selectedResource.link.indexOf('.rtf') !== -1)
                                                    )

                                                    ? <iframe src={"//docs.google.com/gview?url=" + this.state.selectedResource.link + "&embedded=true"} width="100%" height="450" frameBorder="0" allowFullScreen={true} mozallowfullscreen="true" webkitallowfullscreen="true" className="focus-visible" data-focus-visible-added="" onLoad={this.onFileLoaded}></iframe>

                                                    : !IsStringEmpty(this.state.selectedResource.fileContent)
                                                        ? <p><pre>{this.state.selectedResource.fileContent}</pre></p>

                                                        : <iframe src={this.state.selectedResource.link} frameBorder="0" width="100%" height="450" allowFullScreen={true} mozallowfullscreen="true" webkitallowfullscreen="true" className="focus-visible" data-focus-visible-added="" onLoad={this.onFileLoaded}></iframe>
                                                : <p className={classes.MessageText}>Resource File Link is not available!</p>
                                        }
                                    </div> :
                                    this.state.selectedResourceType === 'Embed'
                                        ? <div dangerouslySetInnerHTML={{ __html: this.state.selectedResource.link }} className={classes.EmbedContainer} onLoad={this.onEmbedVideoLoaded}></div>
                                        : null
                            : <div className={classes.MessageText}><p>Resources not available</p></div>
                    }
                    <div className={[classes.ResourcesListContainer, classes.Scroller, this.state.showPlaylist ? classes.ShowPlaylist : null].join(' ')}>
                        {
                            !IsListEmpty(sessionRecording) && (IsStringEmpty(this.props.id) || this.props.id === 2)
                                ? <div className={classes.ResourcesListDiv}>
                                    <p className={classes.ListHeading}>LIVE Session</p>
                                    <ul className={classes.ResourcesList}>
                                        {sessionRecording}
                                    </ul>
                                </div>
                                : null
                        }
                        {
                            (IsStringEmpty(this.props.id) || this.props.id === 1)
                                ? !IsListEmpty(preWatchVideos)
                                    ? <div className={classes.ResourcesListDiv}>
                                        <p className={classes.ListHeading}>
                                            {
                                                this.props.forCertification === true
                                                    ? 'How-To Videos' : 'Pre-watch Videos'
                                            }
                                        </p>
                                        <ul className={classes.ResourcesList}>
                                            {preWatchVideos}
                                        </ul>
                                    </div>
                                    : !IsStringEmpty(this.props.id)
                                        ? <div>
                                            <div className={classes.ListHeading}>Pre-watch Videos</div>
                                            <p className={classes.NoResource}>No Pre-watch videos added</p>
                                        </div> : null
                                : null
                        }
                        {
                            (IsStringEmpty(this.props.id) || this.props.id === 3)
                                ? !IsListEmpty(files)
                                    ? <div className={classes.ResourcesListDiv}>
                                        <p className={classes.ListHeading}>Resource Files</p>
                                        <ul className={classes.ResourcesList}>
                                            {files}
                                        </ul>
                                    </div>
                                    : !IsStringEmpty(this.props.id)
                                        ? <div>
                                            <div className={classes.ListHeading}>References</div>
                                            <p className={classes.NoResource}>No Reference Files added</p>
                                        </div> : null
                                : null
                        }
                        {
                            IsListEmpty(sessionRecording) && IsListEmpty(preWatchVideos) && IsListEmpty(files)
                                ? <p>Resources are not added</p>
                                : null

                        }
                    </div>
                </div>
            </div>
        );
    }
}

export default ResourcesSection;